export default "__VITE_ASSET__BMtqXlLI__"